import React, { useState } from 'react'

import { Portal } from 'react-portal'
import { Placement } from '@popperjs/core'

import { useForDesktop, StatelessDropdown } from '@sketch/components'

import Modal from 'components/Modal'
import ModalTransition from 'containers/ModalManager/ModalTransition'

import {
  CancelButton,
  ItemWrapper,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from './SelectList.styles'
import { lightTheme as theme } from '@sketch/global-styles'

interface SelectListProps {
  expanded: boolean
  children: React.ReactNode
  headerItem?: React.ReactNode
  footerItem?: React.ReactNode
  placement?: Placement
  setExpanded: (
    setExpanded: (state: boolean, button?: HTMLButtonElement) => boolean
  ) => void
  usePortal: boolean
}

function SelectList(props: SelectListProps) {
  const {
    expanded,
    children,
    headerItem,
    footerItem,
    placement = 'bottom-start',
    setExpanded,
    usePortal,
  } = props
  const isDesktopAndBigger = useForDesktop()
  const [hasOverflow, setHasOverflow] = useState(false)

  if (isDesktopAndBigger) {
    return expanded ? (
      <StatelessDropdown
        visible={expanded}
        toggleDropdown={() => {}}
        placement={placement}
        contentPadding="0"
        minWidth="240px"
        maxWidth="320px"
        contentStyle={{
          borderRadius: theme.radii.xxlarge,
        }}
        onClickOutside={e => {
          setExpanded((state, button) => {
            // If it's the button the click handler then no need to override the state
            if (e.target === button) {
              return state
            }
            return false
          })
        }}
        usePortal={usePortal}
      >
        <ItemWrapper>
          {headerItem}
          {children}
        </ItemWrapper>
        {footerItem && <ItemWrapper>{footerItem}</ItemWrapper>}
      </StatelessDropdown>
    ) : null
  } else {
    const handleClose = () => setExpanded(() => false)

    return (
      <Portal>
        <ModalTransition show={expanded}>
          <Modal onCancel={handleClose} onUpdateScroll={setHasOverflow}>
            {headerItem ? (
              <ModalHeader as="div">{headerItem}</ModalHeader>
            ) : null}
            <ModalBody>{children}</ModalBody>
            <ModalFooter hasOverflow={hasOverflow}>
              {footerItem}
              <CancelButton variant="tertiary" small onClick={handleClose} fill>
                Cancel
              </CancelButton>
            </ModalFooter>
          </Modal>
        </ModalTransition>
      </Portal>
    )
  }
}

export default SelectList
